export const SUBSCRIPTION_STATUS_LABELS: { [key: string]: string } = {
    ACTIVE: 'פעיל',
    CANCELED: 'מבוטל',
    EXPIRED: 'פג תוקף',
    UPGRADED: 'שודרג',
    AWAITING_PAYMENT: 'ממתין לתשלום',
    AWAITING_BANK_APPROVAL: 'ממתין לאישור בנק',
    AWAITING_BANK_TRANSFER: 'ממתין להעברה בנקאית',
    BLOCKED: 'חסום',
    CARD_BLOCKED: 'כרטיס חסום'
}
